import { useState } from "react";
import api from "../../services/api";
import { getApiErrorMessage } from "../../utils";
import { useToast } from "../../contexts/toast/toast-context";
import { LoadingButton } from "../button/loading-button";

interface ResetPasswordModalProps {
  title?: string;
  description?: string;
  isOpen: boolean;
  onCancel: () => void;
  onSend: () => void;
}

export function ForgotPasswordModal({
  title = "Digite seu e-mail",
  description,
  isOpen,
  onCancel,
  onSend,
}: ResetPasswordModalProps) {
  const { error, success } = useToast();
  const [recoveryEmail, setRecoveryEmail] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  async function passwordReset(e: React.FormEvent) {
    e.preventDefault();

    if (!recoveryEmail.trim()) {
      error("Por favor, informe um e-mail válido.");
      return;
    }

    try {
      setLoading(true);

      const response = await api.post("/auth/forgot-password", {
        email: recoveryEmail,
      });

      success(response.data);
      setRecoveryEmail("");
      onSend();
    } catch (err) {
      console.log(err);

      const apiMessage = getApiErrorMessage(err);
      error(apiMessage);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <form
        onSubmit={passwordReset}
        className="modal-card"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="mb-4 text-lg font-semibold text-slate-900">{title}</h2>
        {description && (
          <p className="mb-6 text-sm text-slate-600">{description}</p>
        )}

        <input
          type="email"
          value={recoveryEmail}
          onChange={(e) => setRecoveryEmail(e.target.value)}
          className="form-input mb-4"
          required
        />

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="btn btn-secondary cursor-pointer"
            disabled={loading}
          >
            Cancelar
          </button>
          <LoadingButton
            type="submit"
            className="btn btn-primary cursor-pointer"
            isLoading={loading}
            loadingLabel="Enviando"
          >
            Enviar
          </LoadingButton>
        </div>
      </form>
    </div>
  );
}
